(function (root) {
  'use strict';

  function eligible(cart, config) {
    const item = cart.items?.[0];
    return Boolean(config.enabled && config.discountCode && config.available &&
      cart.currency === 'GBP' && cart.items?.length === 1 && cart.item_count === 1 &&
      item.quantity === 1 && String(item.product_id) === String(config.productId) &&
      String(item.variant_id) === String(config.variantId) && !item.selling_plan_allocation &&
      item.original_price === config.singlePrice && item.final_line_price === config.singlePrice &&
      cart.total_price === config.singlePrice && !cart.total_discount &&
      !cart.discount_codes?.some((code) => code.applicable));
  }

  function verified(cart, config) {
    return cart.currency === 'GBP' && cart.items?.length === 1 && cart.item_count === 2 &&
      String(cart.items[0].variant_id) === String(config.variantId) &&
      cart.items[0].quantity === 2 && cart.total_price === config.pairPrice;
  }

  function createDeclineMemory(storage, config) {
    const key = 'sleepspec-pair-decline:v2';
    function signature(cart) {
      return JSON.stringify({
        cart: String(cart.token || '').split('?')[0],
        currency: cart.currency,
        total: cart.total_price,
        discount: cart.total_discount,
        codes: (cart.discount_codes || []).filter((code) => code.applicable)
          .map((code) => code.code).sort(),
        items: (cart.items || []).map((item) => [
          item.key, item.variant_id, item.quantity, item.original_price, item.final_line_price,
        ]),
        offer: [config.discountCode, config.singlePrice, config.pairPrice],
      });
    }
    function clear() {
      try { storage.removeItem(key); } catch (_) {}
    }
    function matches(cart) {
      try {
        const saved = storage.getItem(key);
        if (!saved) return false;
        if (saved === signature(cart)) return true;
        clear();
      } catch (_) {}
      return false;
    }
    function remember(cart) {
      if (!eligible(cart, config)) return;
      try { storage.setItem(key, signature(cart)); } catch (_) {}
    }
    return { clear, matches, remember };
  }

  async function acceptOffer(api, config) {
    const original = await api.get();
    if (!eligible(original, config)) return { status: 'changed', cart: original };
    const oldCodes = (original.discount_codes || []).map((code) => code.code).join(',');
    let mutationStarted = false;
    try {
      mutationStarted = true;
      await api.change({ id: original.items[0].key, quantity: 2 });
      const two = await api.get();
      if (two.items?.length !== 1 || two.item_count !== 2 ||
          String(two.items[0].variant_id) !== String(config.variantId)) {
        return { status: 'review', cart: two };
      }
      await api.update({ discount: config.discountCode });
      const discounted = await api.get();
      if (verified(discounted, config)) return { status: 'accepted', cart: discounted };
      throw new Error('Offer price was not confirmed');
    } catch (_) {
      if (!mutationStarted) return { status: 'unavailable' };
      try {
        const current = await api.get();
        if (verified(current, config)) return { status: 'accepted', cart: current };
        const item = current.items?.[0];
        if (current.items?.length !== 1 || String(item.variant_id) !== String(config.variantId) ||
            ![1, 2].includes(item.quantity)) return { status: 'review', cart: current };
        if (item.quantity === 2) await api.change({ id: item.key, quantity: 1 });
        await api.update({ discount: oldCodes });
        const restored = await api.get();
        return { status: eligible(restored, config) ? 'restored' : 'review', cart: restored };
      } catch (_) {
        return { status: 'review' };
      }
    }
  }

  const api = { eligible, verified, acceptOffer, createDeclineMemory };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.SleepSpecPairOffer = api;
})(typeof window === 'undefined' ? {} : window);
